<mat-dropdown
  [formControl]="shiftSelection.formControl"
  [options]="shiftSelection.options"
  [configurationInput]="shiftSelection.configurationInput"
  [isFormSubmitted]="isFormSubmitted"
></mat-dropdown>

<ng-container *ngFor="let key of shiftOptions">
  <div *ngIf="key <= (selectedOptionId??0) && childDropdowns[key] as item">
    <mat-dropdown
      [formControl]="item.formControl"
      [options]="item.options"
      [configurationInput]="item.configurationInput"
      [isFormSubmitted]="isFormSubmitted"
    >
    </mat-dropdown>
  </div>
</ng-container>
